import React, { useMemo } from 'react';
import AudioPlayer from 'react-player/lazy'
import { isSafari } from 'react-device-detect';
import { getMediaAbsolutePath } from '../../services/File';

type Props = {
  data: string;
};

function ContentAudio(props: Props) {
  const { data } = props;

  const path = useMemo(() => getMediaAbsolutePath(data), [data]);

  if (!data) return null;
  return (
    <AudioPlayer height={54} width={'100%'} controls url={path}
      playsinline
      autoPlay
      playing
      config={{
        file: {
          forceAudio: true,
          attributes: {
            preload: isSafari ? 'none' : 'auto',
            autoPlay: true,
          }
        }
      }}
    />
  );
}

export default ContentAudio;
